export const timeZone = 'Asia/Bangkok'
export const timeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const defaultDateFormat = 'MMMM DD, YYYY'
export const defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm'



// WEBPACK FOOTER //
// ./src/lib/setting.js